module.exports = __webpack_public_path__ + "static/media/java.173b3c0c.png";